export const onChangeNumber = (e) => {
  if (e.target.value.includes(","))
    e.target.value = e.target.value.replace(",", ".");
  if (e.target.value.match(/[a-z]/i)) {
    e.target.value = e.target.value.replace(/[a-z]/i, "");
  }
  return e;
};
